function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */


import Deferred from './deferred';
/**
 * Queue async operations and executes them synchronously.
 */

export var AsyncQueue = /*#__PURE__*/function () {
  function AsyncQueue() {
    _classCallCheck(this, AsyncQueue);

    /**
     * The list of async operations in this queue
     */
    this._operations = [];
  }
  /**
   * Adds the async operation to the queue
   * @param callback An async callback that returns a promise
   * @returns A promise that will get resolved or rejected after executing the callback
   */


  _createClass(AsyncQueue, [{
    key: "enqueue",
    value: function enqueue(callback) {
      var hasPending = !!this._operations.length;
      var deferred = new Deferred();

      this._operations.push({
        deferred: deferred,
        callback: callback
      });

      if (!hasPending) {
        this._processQueue();
      }

      return deferred.promise;
    }
    /**
     * Start processing the queue. This executes the first item and removes it after.
     * Then do the same for next items until the queue is emptied.
     */

  }, {
    key: "_processQueue",
    value: function _processQueue() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$_operations$, deferred, callback, result, error, hasResolved;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._operations.length) {
                  _context.next = 19;
                  break;
                }

                // Grab first item, don't remove from array yet until it's resolved/rejected
                _this$_operations$ = this._operations[0], deferred = _this$_operations$.deferred, callback = _this$_operations$.callback; // We want to capture the result/error first so we can remove the item from the queue later

                result = void 0;
                error = void 0; // Sometimes result and error are empty. So let's use a separate flag to determine if the promise has resolved

                hasResolved = void 0;
                _context.prev = 5;
                _context.next = 8;
                return callback();

              case 8:
                result = _context.sent;
                hasResolved = true;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                error = _context.t0;

              case 15:
                // Remove the item
                this._operations.shift();

                if (hasResolved) {
                  deferred.resolve(result);
                } else {
                  deferred.reject(error);
                }

                _context.next = 0;
                break;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 12]]);
      }));
    }
  }]);

  return AsyncQueue;
}();